import React, {useContext, useEffect, useState} from 'react';
import operatorContext from '../../context/operator/operatorContext'
import {useAlert} from "react-alert";
import ViewOperatorSkills from './ViewOperatorSkills'
import Multiselect from 'multiselect-react-dropdown';

const OperatorDashboard = () => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    const OperatorContext = useContext(operatorContext);
    const {
        operator, getAllSkills, getOperatorSkills, addOperatorSkills, editOperatorSkills,
        toggleAvailability, clearAlert, getAvailabilityStatus
    } = OperatorContext;
    const {skills, operatorSkills, acceptedJobs, pendingJobs, message, isAvailable} = operator


    const alert = useAlert()
    const [availableSkills, setAvailableSkills] = useState([]);
    const [existing_skills, setExisting_skills] = useState([]);

    useEffect(() => {
        if (availableSkills.length === 0){
            getAllSkills().then(all_skill => {
                console.log(existing_skills);

                if (all_skill.length > 0) {
                    getOperatorSkills().then(existing_skills => {

                        filter_skills(all_skill, existing_skills);
                    })

                }

            })

        }

        // getAvailabilityStatus().then(skill_items => {
        //     setOperator_availability_gotten(1)
        // })

        if (message.msg !== "") {
            alert.show(
                message.msg, message.msg_options
            )
            clearAlert()
        }
    }, [existing_skills]);


    function filter_skills (all_skill, existing_skills){
        //format skills for options
        let all_skill_opt = [];
        let existing_skill_opt = [];
        all_skill.map(all_skill_item => {
            all_skill_opt.push({id: all_skill_item.id, name: all_skill_item.name});
        })


        existing_skills.map(all_skill_item => {
            existing_skill_opt.push({id: all_skill_item.skill_id, name: all_skill_item.skill.name});
        })

        //remove existing skills from all skills
        let remaining_skill = all_skill_opt.filter((element) => {
            let is_exist = existing_skill_opt.find(f => element.id === f.id)
            return is_exist === undefined;
        })
        setAvailableSkills(remaining_skill)
        setExisting_skills(existing_skill_opt);

    }
    //Set value for default selection
    const [skill_id, setSkillId] = useState([])
    const [operator_id] = useState(userInfo.id)
    const [isChecked, setIsChecked] = useState(true)


    //Handle onChange event of the dropdown
    const handleChange = e => {
        setSkillId(Array.isArray(e) ? e.map(x => x.value) : []);
    }

    const onSubmit = e => {

        e.preventDefault()

        let operator_skills = document.getElementById("add_operator_skills");
        let user_data = new FormData(operator_skills);
        user_data.append('operator_id', operator_id);
        addOperatorSkills(user_data)
    }

    const onToggleChange = e => {
        setIsChecked(e.target.checked)

        if (e.target.checked === true) {
            toggleAvailability(1)
        } else {
            toggleAvailability(0)
        }
    }

    const data = [
        {value: 20, label: "nkem"},
        {value: 18, label: "dubem"},
        {value: 24, label: "nonso"},
    ]

    return (

        <div className="content-wrapper" style={overFlow}>
            <div className="container-fluid">
                <h3 className="make-bold">Dashboard</h3>
                <h4>Hello {userInfo.last_name}</h4>

                <div className="dashboard-inner-view">
                    <div className="row mt-3">
                        <div className="col-12 col-lg-6 col-xl-4 mb-4">
                            <div className={`card ${isChecked ? `bg-color-3` : `bg-color-1`}`}>
                                <div className="card-body">
                                    <div className="media align-items-center">
                                        <div className="media-body">
                                            <p className="text-white">Toggle Status</p>
                                            <h4 className="text-white line-height-5">{isChecked ? "AVAILABLE" : "UNAVAILABLE"}</h4>
                                        </div>
                                        <form action="" id="toggle_availabilty">
                                            <label className="switch">
                                                <input type="checkbox" name="is_available"
                                                       checked={isAvailable && isAvailable}
                                                       disabled={pendingJobs.length === 0 && acceptedJobs.length === 0 ? "" : "disabled"}
                                                       onChange={onToggleChange}/>
                                                <span type="submit" className="slider round"></span>
                                            </label>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-6 col-xl-4 mb-4">
                            <div className="card  bg-color-2">
                                <div className="card-body">
                                    <div className="media align-items-center">
                                        <div className="media-body">
                                            <p className="text-white">Wallet Balance</p>
                                            <h4 className="text-white line-height-5">N32,500</h4>
                                        </div>
                                        <div className="w-circle-icon rounded-circle border border-white">
                                            <i className="fa fa-pie-chart text-white"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-6 col-xl-4 mb-4">
                            <div className="card bg-color-6">
                                <div className="card-body">
                                    <div className="media align-items-center">
                                        <div className="media-body">
                                            <p className="text-white">Total Jobs</p>
                                            <h4 className="text-white line-height-5">{acceptedJobs ? `${acceptedJobs.length}` : "0"}</h4>
                                        </div>
                                        <div className="w-circle-icon rounded-circle border border-white">
                                            <i className="fa fa-pie-chart text-white"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-12 col-lg-12 col-xl-8 col-sm-8">
                            <h3 className="mb-4">{operatorSkills.length !== 0 ? "UPDATE SKILLS" : "ADD SKILLS"}</h3>
                            <form action="" onSubmit={onSubmit} id="add_operator_skills">
                                <Multiselect
                                    options={availableSkills} // Options to display in the dropdown
                                    selectedValues={existing_skills} // Preselected value to persist in dropdown
                                    // onSelect={this.onSelect} // Function will trigger on select event
                                    // onRemove={this.onRemove} // Function will trigger on remove event
                                    displayValue="name" // Property name to display in the dropdown options
                                />
                                <div className="form-row mt-4">
                                    <div className="form-group col-lg-4">
                                        <input type="submit"
                                               value={operatorSkills.length !== 0 ? "UPDATE SKILLS" : "ADD SKILLS"}
                                               className="btn btn-orange btn-custom-view text-white btn-block d-flex justify-content-center align-items-center"
                                        />
                                    </div>
                                </div>
                            </form>

                        </div>
                        <ViewOperatorSkills/>
                    </div>
                </div>
            </div>
        </div>

    )
}

const overFlow = {
    overflow: 'visible'
}


export default OperatorDashboard;